import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { unpauseColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getUnpause } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "msisdn", "iccid", "status", "last_updated"];

const TmobilejUnpauseBatch = () => (
  <BatchDetail
    title="Un-suspend (Unpause)"
    apiGet={__getUnpause}
    client={CLIENTS.tmobilej}
    columnsFactory={unpauseColumns}
    copyKeys={COPY_KEYS}
    exportAction="unpause"
    retryOperation="unpause"
    showTerminate
    getRowPath={(row) => `/tmobilej/unpause/${row.id}`}
  />
);

export default TmobilejUnpauseBatch;
